module.exports = __webpack_public_path__ + "img/ccmt1.3be2555a.jpg";